// src/components/GolfRouter.tsx
import DebugPage from '@/pages/DebugPage';
import Discover from '@/pages/Discover';
import EditClubPage from '@/pages/EditClubPage';
import Friends from '@/pages/Friends';
import ClubsExplorer from '@/pages/ClubsExplorer';
import Club from '@/pages/Club';
import Landing from '@/pages/Landing';
import MenuPage from '@/pages/MenuPage';
import Messages from '@/pages/Messages';
import NotificationsPage from '@/pages/NotificationsPage';
import PostPage from '@/pages/PostPage';
import Settings from '@/pages/Settings';
import UserPage from '@/pages/UserPage';
import CreateRound from '@/pages/CreateRound';
import { Capacitor } from '@capacitor/core';
import { IonRouterOutlet } from '@ionic/react';
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import SentryTestPage from '@/pages/SentryTestPage';
import Topic from '@/pages/discover/Topic';
import MyBag from '@/pages/MyBag';
import EditMyBag from '@/pages/EditMyBag';

interface GolfRouterProps {
  hasProfile: boolean;
}

const GolfRouter: React.FC<GolfRouterProps> = ({ hasProfile }) => {
  return (
    <IonRouterOutlet>
      <Route exact path="/sentry-test" component={SentryTestPage} />
      <Route exact path="/dashboard" component={Discover} />
      <Route exact path="/discover" component={Discover} />
      <Route exact path="/discover/topic/:topicName" component={Topic} />
      <Route exact path="/friends" component={Friends} />
      <Route path="/messages" component={Messages} />
      <Route exact path="/messages/c/:conversationId" component={Messages} />
      <Route exact path="/notifications" component={NotificationsPage} />
      <Route exact path="/clubs" component={ClubsExplorer} />
      {/* Individual club routes */}
      <Route exact path="/c/:courseId" component={Club} />
      <Route exact path="/c/edit/:courseId" component={EditClubPage} />
      {/* Country and state filtering routes */}
      <Route exact path="/clubs/:country" component={ClubsExplorer} />
      <Route exact path="/clubs/:country/:state" component={ClubsExplorer} />
      <Route exact path="/menu" component={MenuPage} />
      <Route path="/settings" component={Settings} />
      <Route exact path="/debug" component={DebugPage} />
      <Route exact path="/u/:username" component={UserPage} />
      <Route exact path="/p/:postId" component={PostPage} />
      <Route exact path="/create-round" component={CreateRound} />
      <Route exact path="/my-bag" component={MyBag} />
      <Route exact path="/my-bag/edit" component={EditMyBag} />
      <Route exact path="/" render={() => Capacitor.isNativePlatform() ? <Redirect to="/dashboard" /> : hasProfile ? <Redirect to="/dashboard" /> : <Landing />} />
      <Redirect to='/dashboard' />
    </IonRouterOutlet>
  );
};
export default GolfRouter;